import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

declare function require(moduleName: string): any;

@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {
    public get name(): string {
        return environment.environment;
    }

    public get apiKey(): string {
        return environment.apiKey;
    }

    public get baseUrl(): string {
        return environment.baseUrl;
    }

    public get production(): boolean {
        return environment.production;
    }

    public get accountAppUrl(): string | undefined {
        return environment.accountAppUrl;
    }
}
